import actionTypes from '../../action-types'

export default () => ({
  type: actionTypes.IMPORTERS.FETCH_SOMTODAY_INSTITUTES,
})
